import { Component, Vue } from 'vue-property-decorator'
import { listLabel, listOneLabel } from '@/api/product'

/**
 * labelList {Array} 关键字,最终的 产品分类 和 一级标签 数据
 *
 * labelList [
 *  {
 *    label: string,
 *    list: [{
 *      labelId: number,
 *      labelLevel: number,
 *      labelName: string,
 *      tagId: string,
 *      tagName: string
 *    },...]
 *  },
 *  ...
 * ]
 *
 * @description: 获取 产品分类 和 一级标签
 */
@Component({
  name: 'ListLabelMixins'
})
export class ListLabelMixins extends Vue {
  // 最终的 产品分类数据和一级标签数据
  protected labelList:any = []

  // 获取产品标签分类
  async getListLabel () {
    // 1 -> 先拿到所有的 获取产品标签分类
    const res = await listLabel({
      labelType: 1
    })
    if (res.success && res.data.results.length) {
      const labelList: any[] = []
      const arrPromise: any[] = []
      // 2 -> 再根据所有的标签分类去获取一级分类标签
      for (let i = 0; i < res.data.results.length; i++) {
        const item = res.data.results[i]
        labelList.push({
          label: item.labelName
        })
        arrPromise.push(listOneLabel({
          labelId: item.labelId
        }))
      }
      // 应为产品标签分类是个数组，在存在多个的情况下  用 Promise.all 去处理
      Promise.all(arrPromise)
        .then(res => {
          // 3 -> 处理所有拿到 一级分类标签
          for (let i = 0; i < res.length; i++) {
            const item = res[i]
            labelList[i].list = item.data.results || []
          }
          this.labelList = labelList
        })
    }
  }
}
